window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function ($) {
  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Main Script
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  $(function () {
    /* ----------------------------------------------------------------
    Global Variable declarations
    -----------------------------------------------------------------*/
    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY = $("body"),
      IS_INDEX = BODY.hasClass("index-template") ? true : false,
      IS_COLLECTION = BODY.hasClass("collection-template") ? true : false,
      IS_COLLECTION_LISTING = BODY.hasClass("list-collections-template")
        ? true
        : false,
      IS_PRODUCT = BODY.hasClass("product-template") ? true : false,
      IS_BLOG = BODY.hasClass("blog-template") ? true : false,
      IS_ARTICLE = BODY.hasClass("article-template") ? true : false,
      IS_SEARCH = BODY.hasClass("search-template") ? true : false,
      IS_PAGE = BODY.hasClass("page-template") ? true : false,
      IS_CART = BODY.hasClass("cart-template") ? true : false,
      HAS_PRODUCTS = $(".product").length > 0 ? true : false,
      COLLECTION_SIDEBAR = $(".page-sidebar"),
      SIDEBAR_TOGGLE = $(".collection-filtering-toggle");

    REBASE.theme.handleize = function (str) {
      str = str.toLowerCase();

      var toReplace = ['"', "'", "\\", "(", ")", "[", "]", "/"];

      str = str.replace(/\W+/g, "-");

      if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
      }

      if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
      }

      return str;
    };

    /* ----------------------------------------------------------------
    Initializations
    -----------------------------------------------------------------*/
    // Initiate Lazy Loading
    var myLazyLoad = new LazyLoad({
      elements_selector: ".lazy",
      class_loading: "lazyloading",
      class_loaded: "lazyloaded",
    });

    // Re-initialize Lazy Loading on theme editor change
    document.addEventListener("shopify:section:load", function (event) {
      var myLazyLoad = new LazyLoad({
        elements_selector: ".lazy",
        class_loading: "lazyloading",
        class_loaded: "lazyloaded",
      });
    });

    /* ----------------------------------------------------------------
    Navigation
    -----------------------------------------------------------------*/
    // Mobile Navigation
    var mmStatus = "closed";

    function closeMM() {
      mmStatus = "closed";
      $("#mobile-navigation-toggle").toggleClass("opened");
      $("body").removeClass("nav-opened");
    }

    function openMM() {
      mmStatus = "opened";
      $("body").addClass("nav-opened");
      $("#mobile-navigation-toggle").toggleClass("opened");
    }

    $("#mobile-navigation-toggle").on("click", function () {
      if (mmStatus == "closed") {
        openMM();
      } else if (mmStatus == "opened") {
        closeMM();
      }
      return false;
    });
    $(".mobile-dropdown-toggle").on("click", function () {
      $(this).toggleClass("opened").next().toggle();
    });

    function showDD() {
      $(".hover-intent").removeClass("hovered");
      $(this).toggleClass("hovered");
    }

    function hideDD() {
      $(this).removeClass("hovered");
    }

    /* main navigation */
    $(".hover-intent").hoverIntent({
      over: showDD,
      out: hideDD,
      timeout: 350,
    });

    /* footer navigation toggle */
    $(".footer-navigation__item svg").on("click", function (e) {
      e.preventDefault();
      $(this)
        .parents(".footer-navigation__item")
        .toggleClass("footer-navigation__item--open");
    });

    /* footer back-to-top */
    $(".back-to-top").on("click", function (e) {
      e.preventDefault();
      $("html,body").animate({ scrollTop: 0 }, 300);
    });

    // body class for fixed elements on scroll
    $(window).on("scroll", function (e) {
      BODY.toggleClass("scrolled", window.pageYOffset > 41);
    });

    /* ----------------------------------------------------------------
    jQuery toggles
    -----------------------------------------------------------------*/
    //Press Section
    $(".press-view-more").on("click", function (e) {
      e.preventDefault();
      $(this).prev().toggle();
      if ($(this).hasClass("view-more")) {
        $(this)
          .toggleClass("view-more", "view-less")
          .html(
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"/></svg> View Less'
          );
      } else {
        $(this)
          .toggleClass("view-more", "view-less")
          .html(
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"/></svg> View More'
          );
      }
    });

    //FAQ Section
    $(document).on("click", ".faq__title", function (e) {
      $(this).parent().toggleClass("faq--selected");
    });

    //Search dropdown
    $(".header__mobile-search-toggle button").on("click", function (e) {
      e.preventDefault();
      $(".mobile-search-wrapper").toggleClass("mobile-search-wrapper--open");
      if ($(".mobile-search-wrapper").hasClass("mobile-search-wrapper--open")) {
        $(".mobile-search-wrapper input").focus();
      }
    });

    //Login Page - forgot password toggle
    $("#forgot-password").on("click", function () {
      $("#recover-password-form").show();
      $("#customer-login-form").hide();
    });

    $("#forgot-password-cancel").on("click", function () {
      $("#recover-password-form").hide();
      $("#customer-login-form").show();
    });

    //Collection sidebar
    $(".collection-filtering-toggle").on("click", function () {
      $(".page-sidebar .collection-filtering-toggle").toggle();
      COLLECTION_SIDEBAR.toggleClass("shown");
    });

    /* ----------------------------------------------------------------
    Product Loop
    -----------------------------------------------------------------*/
    if (HAS_PRODUCTS) {
      var resize_timer,
        lazySecondaryImg = function () {
          // Lazy Load secondary images for desktop only
          if ($(window).width() > 976) {
            // NOTE: this show() command just removes the display:none inline style. The css will still keep it opacity 0 until hover
            $(".product__image--secondary").show().addClass("lazy");
            myLazyLoad.update();
          }
        };

      // on page laod
      lazySecondaryImg();

      // on window resize
      $(window).on("resize", function (e) {
        clearTimeout(resize_timer);
        resize_timer = setTimeout(lazySecondaryImg, 250);
      });
    }

    /* ----------------------------------------------------------------
    Collection Page
    -----------------------------------------------------------------*/
    if (IS_COLLECTION) {
      $(".filtering-list-max-height-toggle").on("click", function () {
        $(this).prev().toggleClass("filtering-list--max-height");
        $(this).find("span").toggleClass("hidden");
        return false;
      });
    }

    /* ----------------------------------------------------------------
    Product Page - Quantity buttons, Tabs, Reviews, Image Gallery, Options Selects, Swatches
    -----------------------------------------------------------------*/
    if (IS_PRODUCT) {
      REBASE.theme.bindProductControls();
      REBASE.theme.locations.init("product");
    }

    /* ----------------------------------------------------------------
    Quickview Modal
    -----------------------------------------------------------------*/
    // variables
    var modalWrapper = $(".modal-wrapper--quickview"),
      modal = $(".modal-wrapper--quickview .modal"),
      modalClose = $(".modal-wrapper--quickview .modal__close"),
      modalContent = $(".modal-wrapper--quickview .modal__content"),
      modalContentWrapper = $(
        ".modal-wrapper--quickview .modal__content-wrapper"
      );

    // loads product via ajax and runs transitions
    function loadProduct() {
      var product = $(this),
        productData = $(product).data("qv") + "?view=quickview";
      $.get(productData, function (data) {
        // open modal
        $("body").addClass("modal-shown");
        $(modalWrapper).addClass("shown");
        $(modal).addClass("animate");
        $(modalContent).html(data);
        $("#modal__view-details").attr("href", $(product).data("qv"));
        REBASE.theme.unbindProductControls();
        REBASE.theme.bindProductControls();
        REBASE.theme.locations.init("product");
        // REBASE.theme.customBindListsEvents($);

        setTimeout(function () {
          $(product).closest(".product");
          $(product).text("Quick Shop");
          $(modalContentWrapper).addClass("animate");
        }, 300);
      });
    }

    // closes modal
    function closeModal(e) {
      var urlParams = new URLSearchParams(window.location.search);
      e.preventDefault();
      $("body").removeClass("modal-shown");
      $(modal).removeClass("animate");
      $(modalWrapper).removeClass("shown");
      $(modalContentWrapper).removeClass("animate");

      if (REBASE.theme && REBASE.theme.locations) {
        REBASE.theme.locations.productStyleCodes = [];
        REBASE.theme.locations.selectedVariantId = null;
        REBASE.theme.locations.inventory = null;
      }

      urlParams.delete("variant");
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        urlParams.toString();
      window.history.replaceState({ path: newurl }, "", newurl);
    }

    // when quickview is clicked we run loadProduct
    $(".product__quickview").on("click", function (e) {
      e.preventDefault();
      $(this).text("Loading...").closest(".product");
      loadProduct.call($(this));
    });

    $(modalClose).on("click", closeModal);
  });

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Setup Product page controls (needs to run on product pages and when quickview is opened)
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  REBASE.theme.appendToFilename = function (filename, str) {
    var dot_indx = filename.lastIndexOf(".");

    if (dot_indx === -1) {
      return filename + str;
    } else {
      return (
        filename.substring(0, dot_indx) + str + filename.substring(dot_indx)
      );
    }
  };

  REBASE.theme.unbindProductControls = function () {
    $(
      ".add-item-section__toggle--add-on, #product-qty-input, #product-rating, #product-content-sections"
    ).off(".rbProduct");
  };

  REBASE.theme.bindProductControls = function () {
    var product, photo_gallery;

    $(".add-item-section__toggle--add-on").on("click.rbProduct", function (e) {
      e.preventDefault();
      $(this).find("svg").toggleClass("hidden");
      $(this)
        .toggleClass("add-item-section__toggle--active")
        .parent()
        .toggleClass("add-on-product--selected");

      if (typeof calculateAddOnPrice === "function") {
        calculateAddOnPrice();
      }
    });

    // Product Details
    $(".product-detail__header button").on("click.rbProduct", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass("selected").next().stop().slideToggle(150);
    });

    // Quantity buttons
    $(".qtyplus, .qtyminus").show();
    $("#product-qty-input").on(
      "click.rbProduct",
      ".qtyplus, .qtyminus",
      function (e) {
        var quantity_input = $("#quantity"),
          quant_val = parseInt(quantity_input.val());

        e.preventDefault();

        if ($(e.target).hasClass("qtyplus")) {
          if (!quant_val) {
            quant_val = 0;
          }
          quant_val += 1;
        } else {
          if (!quant_val) {
            quant_val = 1;
          }
          if (quant_val > 1) {
            quant_val -= 1;
          }
        }

        quantity_input.val(quant_val);
      }
    );

    // Product Reviews
    $(document).on("click.rbProduct", "#product-rating", function (e) {
      $("html, body").animate(
        { scrollTop: $("#product-reviews").offset().top - 104 },
        500
      );
    });

    // Image Galleries
    if ($(".product__part--gallery").length) {
      photo_gallery = new Swiper(".gallery", {
        effect: "slide",
        loop: false,
        speed: 300,
        autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
        },
      });

      $(document).on("click", ".gallery__thumb", function (e) {
        var _this = $(this),
          index = _this.data("swiper-slide-index");
        photo_gallery.slideTo(index);
      });

      photo_gallery.on("slideChangeEnd", function (e) {
        $(".gallery__thumb").removeClass("gallery__thumb--active");
        $(
          '.gallery__thumb[data-swiper-slide-index="' + e.activeIndex + '"]'
        ).addClass("gallery__thumb--active");
      });

      $(document).on("click", ".zoom-icon", function (e) {
        $(
          '.gallery figure[data-swiper-slide-index="' +
            photo_gallery.activeIndex +
            '"] a'
        ).trigger("click");
      });
    }

    // Option Selectors & Swatches
    // NOTE: must come after image gallery (for selected variant to show correct image when loading page)
    product = new REBASE.theme.Product({
      $container: $("#minicart-add-to-cart-form"),
    });

    REBASE.theme.productInstance = product;
    REBASE.theme.productVariants = product.data.variants;

    function displayRecommendedProducts(products) {
      products.forEach(function (product) {
        var product_loop_template = $("#related-product__template").html();
        var compiled_html = _.template(product_loop_template, product);
        $(".section--related-products .products").append(
          compiled_html({ product: product })
        );
        // if ( REBASE && REBASE.lists ) {
        //   REBASE.lists.updateActiveProductVariant({
        //     product_id: product.id,
        //     variant_id: product.variants[0].id
        //   });
        // }
      });
    }

    function getRecommendedProducts(id) {
      $.getJSON(
        "/recommendations/products.json?product_id=" + id + "&limit=5",
        function (resp) {
          if (resp.products && resp.products.length) {
            displayRecommendedProducts(resp.products);
          } else {
            $(".section--related-products").hide();
          }
        }
      );
    }

    if ($("body").hasClass("product-template")) {
      // NOTE: if related-products section included on page then rehash_related_products will be defined, and this code should run
      if (typeof rehash_related_products !== "undefined") {
        if (rehash_related_products && rehash_related_products.length) {
          displayRecommendedProducts(rehash_related_products);
        } else {
          getRecommendedProducts(product.data.id);
        }
      }
    }
  };

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product class
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Product = (function () {
    function Product(options) {
      var inputs, input_type;

      this.variants = null;
      this.$container = options.$container;
      this.data = JSON.parse(
        document.getElementById("product__json").innerHTML
      );

      this.settings = {
        single_option_selector: ".single-option-select",
        original_select_id: "select#product-select",
      };

      if (this.data) {
        this._initVariants();

        // Trigger change to sync up images, etc on initial page load
        inputs = $(this.settings.single_option_selector, this.$container);
        input_type = inputs.first().attr("type");

        if (input_type === "radio" || input_type === "checkbox") {
          inputs.filter(":checked:first").trigger("change");
        } else {
          inputs.first().trigger("change");
        }
      } else {
        if (console) {
          console.log("Missing product json data!");
        }
      }
    }

    Product.prototype = $.extend({}, Product.prototype, {
      _initVariants: function () {
        var options = {
          $container: this.$container,
          enable_history_state: true,
          single_option_selector: this.settings.single_option_selector,
          original_select_id: this.settings.original_select_id,
          product: this.data,
        };

        this.variants = new REBASE.theme.Variants(options);

        this.$container.on("variantChange", this._updateAddToCart.bind(this));
        this.$container.on(
          "variantChange",
          this._updateAvailableOptions.bind(this)
        );
        this.$container.on("variantImageChange", this._updateImages.bind(this));
        this.$container.on("variantPriceChange", this._updatePrice.bind(this));
        this.$container.on("variantSKUChange", this._updateSKU.bind(this));
        $(document).on(
          "locationInventoryUpdated inventoryFetched",
          this._handleLocationInventoryUpdated.bind(this)
        );
      },

      _handleLocationInventoryUpdated: function () {
        var inputs = $(this.settings.single_option_selector, this.$container);
        var input_type = inputs.first().attr("type");

        if (input_type === "radio" || input_type === "checkbox") {
          inputs.filter(":checked:first").trigger("change");
        } else {
          inputs.first().trigger("change");
        }
      },

      _isAvailable: function (variant) {
        var pickupType = $('input[name="properties[_shipping]"]:checked').val(),
          key =
            pickupType === "shipped"
              ? "shopify_inventory_quantity"
              : "inventory_quantity",
          inventory = null;

        // console.warn('********** _isAvailable pickupType', pickupType)

        try {
          inventory = REBASE.theme.locations.getSelectedVariantInventory();
        } catch (e) {
          console.error(e);
        }

        if (inventory) {
          return inventory[key] > 0;
        } else {
          return variant.available;
        }
      },

      _updateAddToCart: function (e) {
        var variant = e.variant,
          target = $(e.target),
          input_type = target.attr("type"),
          add_to_cart_btn = $("#add-to-cart"),
          btn_txt = $("#add-to-cart-text"),
          btn_txt_value = btn_txt.data("add-to-cart-text");

        if (!variant) {
          add_to_cart_btn.addClass("disabled").attr("disabled", "disabled");
          btn_txt.text("Not Available");
          $(".product-pricing .product-price").html(
            "<span>Not Available</span>"
          );
          $(".product-pricing .old-price").empty();
        } else {
          if (this._isAvailable(variant)) {
            add_to_cart_btn.removeClass("disabled").removeAttr("disabled");
            btn_txt.text(btn_txt_value);
          } else {
            add_to_cart_btn.addClass("disabled").attr("disabled", "disabled");
            btn_txt.text("Sold Out");
          }
        }

        if (input_type === "radio" || input_type === "checkbox") {
          target
            .parent(".swatch-element")
            .addClass("selected-swatch")
            .siblings()
            .removeClass("selected-swatch");
        }
      },
handleize(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
},

_updateAvailableOptions: function (e) {
  var self = this;

  if (window.product && Array.isArray(window.product.variants)) {
    var optionHandle = $(".swatch").data("option");

    var optionIndex = window.product.options.findIndex(function (opt) {
      return self.handleize(opt) === optionHandle;
    });

    if (optionIndex === -1) return;

    window.product.variants.forEach(function (variant) {
      var value = variant.options[optionIndex];
      if (!value) return;

      var handledValue = self.handleize(value);

      if (!variant.available) {
        $(".swatch-element--" + handledValue).addClass("swatch--unavailable");
      } else {
        $(".swatch-element--" + handledValue).removeClass("swatch--unavailable");
      }
    });
  }
}


 
,
      _updateImages: function (e) {
        var variant = e.variant,
          selected_thumb = $(
            '.gallery__thumbnail-wrapper[data-image-id="' +
              variant.featured_image.id +
              '"]'
          );

        if (
          selected_thumb.length &&
          !selected_thumb.hasClass("image-gallery__thumbnail-wrapper--active")
        ) {
          selected_thumb.trigger("click");
        }
      },
      _updatePrice: function (e) {
        var variant = e.variant,
          main_price = $(".product-pricing .product-price"),
          old_price = $(".product-pricing .old-price"),
          compare_price = variant.compare_at_price;

        main_price.html(
          Shopify.formatMoney(variant.price, Shopify.money_format).replace(
            ".00",
            ""
          )
        );

        if (compare_price && compare_price > variant.price) {
          old_price.html(
            Shopify.formatMoney(compare_price, Shopify.money_format).replace(
              ".00",
              ""
            )
          );
        } else {
          old_price.empty();
        }
      },
      _updateSKU: function (e) {
        $("#product-sku .product-meta-item-content").text(e.variant.sku);
      },
    });

    return Product;
  })();

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product Variants class - based on Shopify debut
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Variants = (function () {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.single_option_selector = options.single_option_selector;
      this.original_select_id = options.original_select_id;
      this.enable_history_state = options.enable_history_state;
      this.current_variant = {};

      $(this.single_option_selector, this.$container).on(
        "change",
        this._onSelectChange.bind(this)
      );
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function () {
        var should_filter = false,
          the_options = $.map(
            $(this.single_option_selector, this.$container),
            function (element) {
              var $element = $(element),
                type = $element.attr("type"),
                current_option = {};

              if (type === "radio" || type === "checkbox") {
                should_filter = true;

                if ($element[0].checked) {
                  current_option.value = $element.val();
                  current_option.index = $element.data("index");
                  return current_option;
                } else {
                  return false;
                }
              } else {
                current_option.value = $element.val();
                current_option.index = $element.data("index");
                return current_option;
              }
            }
          );

        // Remove any unchecked input values if using radio buttons or checkboxes
        // Removes all falsy values (Boolean constructor is a function, if the value is omitted or is 0, -0, null, false, NaN, undefined, or the empty string ("") then it will get removed)
        if (should_filter) {
          the_options = the_options.filter(Boolean);
        }

        return the_options;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selected_values - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function () {
        var selected_values = this._getCurrentOptions(),
          variants = this.product.variants,
          all_variants_match_option1,
          found;

        found = $.grep(variants, function (variant) {
          return selected_values.every(function (values) {
            return variant[values.index] === values.value;
          });
        });

        all_variants_match_option1 = $.grep(variants, function (variant) {
          return variant[selected_values[0].index] === selected_values[0].value;
        });

        if (found.length) {
          found = found[0];
        } else {
          found = undefined;
        }

        return {
          variant_match: found,
          all_variants_match_option1: all_variants_match_option1,
        };
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function (e) {
        var variant_from_options = this._getVariantFromOptions(),
          variant;

        variant = variant_from_options.variant_match;
        REBASE.theme.locations.selectedVariantId = variant.id;

        this.$container.trigger({
          type: "variantChange",
          variant: variant,
          all_variants_match_option1:
            variant_from_options.all_variants_match_option1,
          target: e.target,
        });

        if (!variant) {
          this.current_variant = {};
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.current_variant = variant;

        if (this.enable_history_state) {
          this._updateHistoryState(variant);
        }

        // also tell our locations code to update itself
        if (REBASE.theme.locations.inventory) {
          REBASE.theme.locations.handleInventoryFetched();
        }
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function (variant) {
        var variant_image = variant.featured_image || {},
          current_variant_image = this.current_variant.featured_image || {};

        if (
          !variant.featured_image ||
          variant_image.src === current_variant_image.src
        ) {
          return;
        }

        this.$container.trigger({
          type: "variantImageChange",
          variant: variant,
        });
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function (variant) {
        if (
          variant.price === this.current_variant.price &&
          variant.compare_at_price === this.current_variant.compare_at_price
        ) {
          return;
        }

        this.$container.trigger({
          type: "variantPriceChange",
          variant: variant,
        });
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function (variant) {
        if (variant.sku === this.current_variant.sku) {
          return;
        }

        this.$container.trigger({
          type: "variantSKUChange",
          variant: variant,
        });
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var urlParams = new URLSearchParams(window.location.search);
        urlParams.set("variant", variant.id);
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          urlParams.toString();
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function (variant) {
        $(this.original_select_id, this.$container).val(variant.id);
      },
    });

    return Variants;
  })();
})(jQuery);
